/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ProgramPeriod } from '../../models/program-period';

export interface FindOneProgramPeriod$Params {
  programSlug: string;
  programPeriodSlug: string;
}

export function findOneProgramPeriod(
  http: HttpClient,
  rootUrl: string,
  params: FindOneProgramPeriod$Params,
  context?: HttpContext
): Observable<StrictHttpResponse<ProgramPeriod>> {
  const rb = new RequestBuilder(rootUrl, findOneProgramPeriod.PATH, 'get');
  if (params) {
    rb.path('programSlug', params.programSlug, {});
    rb.path('programPeriodSlug', params.programPeriodSlug, {});
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ProgramPeriod>;
    })
  );
}

findOneProgramPeriod.PATH = '/program/{programSlug}/periods/{programPeriodSlug}';
